export function AssistantEmpty() {
  return (
    <div className="flex flex-1 items-center justify-center px-6 text-center">
      <p className="font-display text-[14px] leading-snug text-white/55 italic">
        Ask about this client. I can see their last 3 sessions and what&apos;s said on this call.
      </p>
    </div>
  );
}
